import {
  IFinancialConnectionsAccount,
  IPaymentMethod,
  OrEmptyString,
  PaymentMethodSource,
  PaymentMethodStatus,
} from "config/types";
import { logout } from "store/actions/authentication";
import { createPaymentMethod, getActivePaymentMethod } from "store/actions/payment";

import { createReducer } from "@reduxjs/toolkit";

export interface IPaymentState extends Omit<IPaymentMethod, "source" | "status"> {
  status: OrEmptyString<PaymentMethodStatus>;
  source: OrEmptyString<PaymentMethodSource>;
}

const defaultState = {
  id: "",
  name: "",
  metadata: {} as Record<string, unknown>,
  status: "" as OrEmptyString<PaymentMethodStatus>,
  source: "" as OrEmptyString<PaymentMethodSource>,
  externalId: "",
  mask: "",
  financialConnectionsAccount: null as IFinancialConnectionsAccount | null,
  createdAt: "",
  updatedAt: "",
} satisfies IPaymentState;

const payment = createReducer(defaultState, builder => {
  builder
    .addCase(getActivePaymentMethod.fulfilled, (state, action) => {
      const paymentMethod = action.payload;

      return { ...state, ...paymentMethod };
    })
    .addCase(createPaymentMethod.fulfilled, (state, action) => {
      const paymentMethod = action.payload;

      return { ...state, ...paymentMethod };
    })
    .addCase(logout, () => defaultState);
});

export default payment;
